export const img_url_api = `${process.env.REACT_APP_AWS_S3_ENDPOINT}`;
// export const img_url_api = "https://zote-innovation.s3.ap-southeast-2.amazonaws.com/ada-localhost/";
